/**
 * FeedbackCategoryService
 * Service for FeedbackCategory entity operations
 * Route: api/feedbackcategory
 */
import { CrudService } from '../base/CrudService';
/**
 * FeedbackCategoryService
 * Handles feedback category CRUD operations
 */
export class FeedbackCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FeedbackCategoryService.DEFAULT_SERVICE_PATH,
            basePath: FeedbackCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET RECIPIENTS ====================
    /**
     * Get recipients for a feedback category
     * GET api/feedbackcategory/{id}/recipients
     */
    async getRecipients(id) {
        const response = await this.getRecipientsRaw(id);
        return response.data ?? [];
    }
    /**
     * Get recipients for a feedback category with full response
     */
    getRecipientsRaw(id) {
        const endpoint = this.getEndpoint('recipients', `${id}/recipients`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
FeedbackCategoryService.DEFAULT_SERVICE_PATH = 'feedback';
FeedbackCategoryService.BASE_PATH = 'api/feedbackcategory';
//# sourceMappingURL=FeedbackCategoryService.js.map